import React, { useState } from "react";
// models
import { PostulacionModel, initialValuesPostulacionModel } from "../models/PostulacionesModel/postulacion.model";
// api services
import apiParticipantes from "../api/Participantes/api-participantes";
// another imports
import fileDownload from "js-file-download";
import apiConvocatorias from "../api/Convocatorias/api-convocatorias";
import { openNotification } from '../utils/Notifactions';
import DocumentosService from "../api/Documentos/api-documentos";
import getStorageUser from "../middlewares/GetStorageUser";

export const useMisPostulacionesJurado = () => {
  const [postulaciones, setPostulaciones] = useState<any>([]);
  const [postulacionState, setPostulacionState] = useState<any>({});
  const [totalregistros, setTotalregistros] = useState<number>(0);
  const [cantidadPáginas, setCantidadPáginas] = useState<number>(10);
  const [modal, setModal] = useState<boolean>(false);
  const [lineasConvocatorias, setLineasConvocatorias] = useState<any>([]);
  const [postulacion, setPostulacion] = useState<PostulacionModel>(initialValuesPostulacionModel);
  // subsanar documentos
  const [documentosSubsanar, setDocumentosSubsanar] = useState<any>([]);
  const [totalDocumentosSubsanar, setTotalDocumentosSubsanar] = useState<number>(0);
  const [cantidadPáginasSubsanar, setCantidadPáginasSubsanar] = useState<number>(10);
  const [openModalWarning, setOpenModalWarning] = useState(false);
  const [datosFiltrados, setDatosFiltrados] = useState([])

  const onAceptar = () => {
    return setOpenModalWarning(false);
  };

  const actualizarEstadoSiVencido = (postulacion: any, fecha_informeRaw: any) => {
    if (fecha_informeRaw === null || isNaN(Date.parse(fecha_informeRaw))) return;
    const fechaInforme = new Date(fecha_informeRaw);
    fechaInforme.setDate(fechaInforme.getDate() + 1);
    if (new Date() < fechaInforme) {
      postulacion.estado = "Inscrito sin revisar";
      postulacion.observaciones = "";
      if (postulacion.status) postulacion.status = "Inscrito sin revisar";
    }
  };

  const cargarPostulaciones = async (artistCall = false) => {
    try {
      const user = getStorageUser();
      let { data } = await apiParticipantes.consultarPostulacionesJurado(user.documento);
      console.log('data -----', data)
      const subsanar = [];
      setTotalregistros(data.length);

      for (const postulacion of data) {
        const esSubsanableOriginal = postulacion.estado === "Subsanar";

        if (["Subsanar", "Aceptado", "Rechazado"].includes(postulacion.estado)) {
          try {
            const convocatoria = await apiConvocatorias.getConvocatoriaById(postulacion.convocatoria_id);
            const fecha_informeRaw = convocatoria.data.fechas
              ?.filter((item) => item.clave === "Primer informe de verificación de documentos")[0]
              ?.valormax ?? null;
            actualizarEstadoSiVencido(postulacion, fecha_informeRaw);
          } catch (error) {
            console.error('Error al obtener la convocatoria:', error);
          }
        }

        if (esSubsanableOriginal) {
          subsanar.push(postulacion);
        }
      }

      setDatosFiltrados(data);
      setDocumentosSubsanar(subsanar);
      setTotalDocumentosSubsanar(subsanar.length);
      if (subsanar && subsanar.length > 0) setOpenModalWarning(true);
      return setPostulaciones(data);
    } catch (error) {
      console.error('Error al cargar las postulaciones:', error);
    }
  };

  const guardarArchivosAdministrativos = async (datos: any, e: any, index: number, post: Array<PostulacionModel>) => {
    try {
      if (e.target.files[0].size > 5000000) {
        return openNotification({
          titulo: "Error",
          descripcion: "Solo se permiten archivos menores a 5MB",
          placement: "bottomRight",
        });
      }
      const formData = new FormData();
      formData.append("archivo", e.target.files[0]);
      const data = await DocumentosService.guardarArchivo(formData);
      let nuevosdocumentos: any = postulacionState.documentos_administrativos.map((doc: any, indexdoc: number) => {
        if (!doc.tipo_documento) doc.tipo_documento = doc.descripcion;
        if (datos.tipo_documento === doc.tipo_documento) {
          return {
            ...doc,
            url_participante: data.data,
            checksubsanable: false,
            checksubsanado: true,
          };
        }
        return {
          ...doc,
        };
      });
      let infoupdate = [...documentosSubsanar];
      for (const i in infoupdate) {
        infoupdate[i].documentos_administrativos = nuevosdocumentos;
      }
      setDocumentosSubsanar(infoupdate);
      return setPostulacionState({ ...postulacionState, documentos_administrativos: nuevosdocumentos });
    } catch (error) {
      return console.error(error);
    }
  };
  const cambiarEstadoPostulaciónDocumentos = async () => {
    let nuevaspostulaciones = postulaciones.map((data: any) => {
      if (data.id_postulacion === postulacionState.id_postulacion) {
        return postulacionState;
      }
      return data;
    });
    await apiParticipantes.guardarDocumentosAdministrativosPostulacion(
      postulacionState.id_postulacion,
      postulacionState.documentos_administrativos
    );
    let estado = "Subsanado";
    let subsanar = postulacionState.documentos_administrativos.filter((data: any) => data.checksubsanable);
    if (subsanar.length > 0) estado = "Subsanar";
    await apiParticipantes.cambiarEstadoPostulacion({
      id_postulacion: postulacionState.id_postulacion,
      estado: estado,
    });
    return setPostulaciones(nuevaspostulaciones);
  };
  const cambiarCantidadPaginas = (e: any, value: any) => {
    return setCantidadPáginas(value);
  };
  const cambiarCantidadPaginasDocumentos = (e: any, value: any) => {
    return setCantidadPáginasSubsanar(value);
  };
  const descargarArchivo = async (url: string) => {
    let data: any = await DocumentosService.consultarArchivo(url);
    await fileDownload(data, url);
  };
  const obtenerLineasConvocatorias = async () => {
    let data = await apiConvocatorias.getLineaConvocatorias();
    return setLineasConvocatorias(data.data);
  }
  const verPropuesta = (datos: PostulacionModel) => {
    setPostulacion(datos);
    return setModal(true);
  }

  return {
    postulaciones,
    setPostulaciones,
    cargarPostulaciones,
    guardarArchivosAdministrativos,
    setPostulacionState,
    totalregistros,
    setTotalregistros,
    cantidadpáginas: cantidadPáginas,
    cambiarCantidadPaginas,
    documentossubsanar: documentosSubsanar,
    totaldocumentossubsanar: totalDocumentosSubsanar,
    cantidadpáginassubsanar: cantidadPáginasSubsanar,
    cambiarCantidadPaginasDocumentos,
    cambiarEstadoPostulaciónDocumentos,
    modal,
    setModal,
    descargarArchivo,
    obtenerLineasConvocatorias,
    lineasconvocatoria: lineasConvocatorias,
    postulacion,
    setPostulacion,
    verPropuesta,
    setDocumentosSubsanar,
    datosFiltrados,
    setDatosFiltrados,
    openModalWarning,
    setOpenModalWarning,
    onAceptar
  };
};
